module.exports = __webpack_public_path__ + "img/special4.7a35f2c4.png";